import { ArrowDownRight, ArrowUpRight, Radio } from "lucide-react";
import { fmtMXN, fmtPct, monthLabel, timeAgo } from "./format";

export function SyncBadge({ lastSync }) {
  const live = lastSync && Date.now() - new Date(lastSync).getTime() < 30 * 60 * 1000;
  return (
    <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-widest font-mono text-neutral-400 border border-white/10 px-3 py-1.5 rounded-full" data-testid="inv-sync-badge">
      <span className={`relative flex h-2 w-2 ${live ? "" : "opacity-60"}`}>
        {live && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${live ? "bg-emerald-400" : "bg-neutral-500"}`} />
      </span>
      <Radio size={11} /> RubiPOS · {timeAgo(lastSync)}
    </div>
  );
}

export function Delta({ value, suffix = "vs mes anterior" }) {
  if (value == null) return <span className="text-[11px] text-neutral-500 font-mono">sin comparativo</span>;
  const up = value >= 0;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-mono ${up ? "text-emerald-400" : "text-rose-400"}`}>
      {up ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
      {fmtPct(Math.abs(value))} <span className="text-neutral-500">{suffix}</span>
    </span>
  );
}

export function KpiCard({ label, value, sub, testId, accent }) {
  return (
    <div className={`rounded-2xl border p-5 relative overflow-hidden ${accent ? "border-[#FFBF57]/30 bg-[#FFBF57]/[0.04]" : "border-white/8 bg-[#111112]"}`} data-testid={testId}>
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 font-mono">{label}</div>
      <div className="font-mono text-2xl md:text-3xl mt-3 text-white tabular-nums">{value}</div>
      {sub && <div className="mt-2">{sub}</div>}
    </div>
  );
}

export function CutHero({ month, cut, prevCut, pcts, deltaPct }) {
  const delta = prevCut ? ((cut - prevCut) / prevCut) * 100 : null;
  return (
    <div className="rounded-3xl border border-[#FFBF57]/25 bg-[#0F0E0B] p-7 md:p-9 relative overflow-hidden" data-testid="inv-cut-hero">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#FFBF57]/10 blur-3xl pointer-events-none" />
      <div className="relative">
        <div className="text-[10px] uppercase tracking-widest text-[#FFBF57] font-mono">Tu corte estimado · {monthLabel(month)}</div>
        <div className="font-mono text-5xl md:text-6xl lg:text-7xl text-white mt-4 tabular-nums tracking-tight" data-testid="inv-cut-value">{fmtMXN.format(cut || 0)}</div>
        <div className="mt-4 flex flex-wrap items-center gap-4">
          <Delta value={delta} suffix="vs corte anterior" />
          {deltaPct != null && <Delta value={deltaPct} suffix="ventas vs mes anterior" />}
        </div>
        <div className="mt-6 flex flex-wrap gap-2">
          {pcts.map((p) => (
            <span key={p.branch_id} className="text-[10px] font-mono uppercase tracking-wider text-neutral-300 border border-white/10 rounded-full px-3 py-1">
              {p.name} · <span className="text-[#FFBF57]">{p.pct}%</span> utilidad neta
            </span>
          ))}
        </div>
        <p className="text-[11px] text-neutral-500 mt-5 max-w-lg leading-relaxed">
          Cálculo en vivo sobre la utilidad neta acumulada del mes (ventas − costo de mercancía − gastos operativos). El corte definitivo se confirma al cierre contable y se paga los primeros 10 días del mes siguiente.
        </p>
      </div>
    </div>
  );
}
